<mat-card appearance="outlined">
  <mat-card-title>
    <span class="title">{{ 'ccr.standalonePageTitle' | translate }}</span>
  </mat-card-title>
  <mat-card-subtitle> </mat-card-subtitle>
  <mat-card-content>
    <form>
      <div layout="column" class="title" flex-gt-md="50">
        <mat-form-field
          class="white-space-no-wrap right-padding-16"
          [style.max-width.px]="300"
        >
          <input
            matInput
            type="text"
            [formControl]="identifier"
            placeholder="{{ 'global.identifier' | translate }}"
          />
          @if (
            identifier.hasError('onlyNumbers') ||
            identifier.hasError('minlength') ||
            identifier.hasError('maxlength') ||
            identifier.hasError('invalidIdentifier')
          ) {
            <mat-error [translate]="'clients.invalidIdentifier'"
              >Invalid EGN or EIK
            </mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>
@if (showTable) {
  <mat-card appearance="outlined">
    <mat-card-content>
      <div>
        <itfg-ccr-report [inputClient]="client"></itfg-ccr-report>
      </div>
    </mat-card-content>
  </mat-card>
}
@if (!showTable) {
  <div layout="row" layout-align="center">
    <h3 class="edit-screen-card-title">
      {{ 'ccr.enterValidIdentifier' | translate }}
    </h3>
  </div>
}
